import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import { PremiumTrash } from '@wix/da-ds/pkg/Icons/Confirmations';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import { DeviationTypes } from '../../../types/deviation';
import TierCreatorReduxModule from '../../../Tier/redux/creator/ModuleLoadable';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ConfirmationModal from '../../../Popup/ConfirmationModal';
import { deviationTypeToTranslationKey, getDeviationType, getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
import s from './DeleteButton.scss';
export const DeleteButton = ({ deviation, onClick })=>{
    var _deviation_extended_adoptable, _deviation_extended, _deviation_extended_adoptable1, _deviation_extended1, _deviation_author;
    const { t } = useTranslation();
    const [isShowingConfirmation, setShowingConfirmation] = useState(false);
    const isAdopted = deviation.isAdoptable && ((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.owner) && ((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_adoptable1 = _deviation_extended1.adoptable) === null || _deviation_extended_adoptable1 === void 0 ? void 0 : _deviation_extended_adoptable1.owner.username) !== ((_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username);
    const [isConfirmable, setIsConfirmable] = useState(!isAdopted);
    const toggleIsConfirmable = useCallback(()=>{
        setIsConfirmable(!isConfirmable);
    }, [
        setIsConfirmable,
        isConfirmable
    ]);
    const logBiEvent = useBiLogger();
    const type = getDeviationType(deviation);
    const typeName = t(deviationTypeToTranslationKey(type));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TierCreatorReduxModule, null), /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: t('actionbar.delete')
    }, /*#__PURE__*/ React.createElement(ActionBarEditButton, {
        onClick: ()=>{
            if (type === DeviationTypes.TIER) {
                onClick({
                    deviation
                });
            } else {
                setShowingConfirmation(true);
            }
        },
        biData: {
            evid: BiEventType.DEVIATION_DELETE_CLICK,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        }
    }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
        icon: TrashcanIcon
    }))), /*#__PURE__*/ React.createElement(ConfirmationModal, {
        isOpen: isShowingConfirmation,
        title: t('actionbar.delete.confirm', {
            type: typeName
        }),
        text: isAdopted ? /*#__PURE__*/ React.createElement("div", null, t('actionbar.delete.cantGoBack.adopted'), /*#__PURE__*/ React.createElement(BooleanInput, {
            type: "checkbox",
            size: "small",
            id: "delete-confirm",
            value: isConfirmable,
            className: s['checkbox'],
            label: t('actionbar.delete.cantGoBack.adopterConsent'),
            labelClassName: s['checkbox-label'],
            onChange: toggleIsConfirmable
        })) : t('actionbar.delete.cantGoBack'),
        confirmBtnLabel: t('actionbar.delete'),
        cancelBtnLabel: t('popup.cancel'),
        icon: /*#__PURE__*/ React.createElement(PremiumTrash, null),
        confirmBtnType: "danger",
        confirmBtnDisabled: !isConfirmable,
        onConfirm: ()=>{
            logBiEvent({
                evid: BiEventType.DELETE_DEVIATION_CONFIRM_CLICK,
                itemid: deviation.deviationId,
                typeid: getDeviationResourceType(deviation)
            });
            setShowingConfirmation(false);
            onClick({
                deviation,
                shouldRedirect: true
            });
        },
        onCancel: ()=>setShowingConfirmation(false)
    }));
};
DeleteButton.displayName = 'DeleteButton';
export default DeleteButton;
